/**
 * Mail Overview App Definition
 *
 * Lightweight gallery of the user's Mail.Thread entities — the Mail
 * equivalent of the Docs/Sheets "overview" home. Individual threads always
 * route to EmailEntityView (see entityTypeMapping.ts), never back to this
 * app, so this window can only ever be in the gallery/home state.
 *
 * Deliberately separate from MailApp ('mail'), the full tri-pane inbox —
 * both stay `experimental: true` for now while Mail is hardened further.
 */

import { AppDefinition } from '../../types/apps';

export const MailOverviewAppDefinition: AppDefinition = {
  appId: 'mail-overview',
  name: 'Mail',
  version: '1.0.0',
  description: 'Browse your email threads and drafts',

  icon: {
    type: 'phosphor',
    phosphorIcon: 'Envelope',
    phosphorWeight: 'duotone',
    color: '#ec4899',
  },

  entityTypes: [],
  component: 'MailOverviewApp',
  requiresProps: false,
  requiresEntity: false,
  experimental: true,

  features: [
    'Browse all email threads and drafts',
    'Compose a new email',
    'Opens individual threads in the standalone email view',
  ],

  actions: {},
};
